import {
  ItemPrice,
  SubscriptionsEstimateResponse,
  SubscriptionEstimatePayload,
  PlansResponse,
  ChangeSubscriptionEstimateResponse,
} from '~/types/prices'
import { ApiKy } from './index'
import { CurrencyCode } from '~/types/countries'
import { BillingPeriod } from '~/types/subscriptions'

type EstimateSearchParams = {
  sendEmail?: boolean
  emailAddress?: string
}

const buildEstimateSearchParams = (
  sendEmail?: boolean,
  emailAddress?: string,
): EstimateSearchParams => ({
  ...(sendEmail !== undefined && { sendEmail }),
  ...(emailAddress !== undefined && { emailAddress }),
})

export default class Api extends ApiKy {
  get(currencyCode: CurrencyCode) {
    return this.ky
      .get(`${this.url}/items`, {
        searchParams: { currencyCode },
      })
      ?.json<ItemPrice[]>()
  }

  getItem(id: string) {
    return this.ky.get(`${this.url}/items/${id}`)?.json<ItemPrice>()
  }

  getPlans(currencyCode: CurrencyCode, billingPeriod: BillingPeriod) {
    return this.ky
      .get(`${this.url}/plans`, {
        searchParams: { currencyCode, billingPeriod },
      })
      ?.json<PlansResponse>()
  }

  postSubscriptionEstimate(
    partnerId: string,
    payload: SubscriptionEstimatePayload,
    sendEmail?: boolean,
    emailAddress?: string,
  ) {
    const searchParams = buildEstimateSearchParams(sendEmail, emailAddress)

    return this.ky
      .post(`${this.url}/subscriptions/partners/${partnerId}`, {
        json: payload,
        searchParams,
      })
      ?.json<SubscriptionsEstimateResponse>()
  }

  getChangeSubscriptionEstimate(
    subscriptionId: string,
    numOfPrinters: number,
    sendEmail?: boolean,
    emailAddress?: string,
  ) {
    const searchParams = {
      subscriptionId,
      numOfPrinters,
      ...buildEstimateSearchParams(sendEmail, emailAddress),
    }

    return this.ky
      .get(`${this.url}/subscriptions/${subscriptionId}`, {
        searchParams,
      })
      ?.json<ChangeSubscriptionEstimateResponse>()
  }

  getSubscriptionEstimateById(
    subscriptionId: string,
    sendEmail?: boolean,
    emailAddress?: string,
    couponId?: string,
  ) {
    const requestOptions: {
      searchParams: EstimateSearchParams
      json?: { couponId: string }
    } = {
      searchParams: buildEstimateSearchParams(sendEmail, emailAddress),
      ...(couponId && { json: { couponId } }),
    }

    return this.ky
      .post(
        `${this.url}/subscriptions/renewal/${subscriptionId}`,
        requestOptions,
      )
      ?.json<SubscriptionsEstimateResponse>()
  }
}
